import { styled } from '@mui/material'
import { Caption } from '@collaborate-health/uikit'

export const MultiLineCaption = styled(Caption)({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

